//CHARTJS METHODS
$(function() {
    let downloadChart = $('.download-chart>a');
    let chartPanel = $('.chart-card');

    chartPanel.hover(function () {
        $(this).find('.download-chart>a').removeClass('hidden');
    }, function() {
        $(this).find('.download-chart>a').addClass('hidden');
    });

    downloadChart.click( function () {
        let chartImg, filename = '';
        let chartId = $(this).parents('.chart-card').find('canvas').get(0).id;

        Object.entries(Chart.instances).forEach(instance => {
            let chartInfo = instance[1];
            // This ternary operator is used to get this script working with
            // ChartJS v2 (chartInfo.chart) and v3 (chartInfo.$context.chart)
            let chart = (chartInfo.$context !== undefined) ? chartInfo.$context.chart : chartInfo.chart;

            let chartInstanceCanvasId = chartInfo.canvas.id;

            if (chartInstanceCanvasId === chartId) {
                chartImg = chart.toBase64Image();
                filename = chartInstanceCanvasId + '.png';
            }
        });

        $(this).attr('href', chartImg);
        $(this).attr('download', filename);
    });
});

const DOUGHNUT_CHART_COLORS = [
    "#35A7FF", "#f1667d", "#FFCE56",
    "#E5E5E5", "#FF9430",
    "#97cf16", "#164666", "#FFB575",
    "#a2b5c2", "#fabebe", "#f032e6",  "#750CE8", "#00CC9B"
];

const STACKED_CHART_COLORS = [
    "#FFCE56", "#35a7ff", "#00CC9B", "#f1667d",
    "#a2b5c2", "#164666", "#97cf16",
    "#ea7100", "#FFB575", "#a2b5c2",
    "#fabebe", "#f032e6", "#750CE8"
];

const SIMPLE_BAR_CHART_COLOR = "#00CC9B";
const COMPARISON_LOGS_DOUGHNUT_CHART_COLORS =  ["#00CC9B", "#FFCE56", "#35a7ff", "#f1667d"];

const CHART_LINK_BY_LEVEL = {
    baseURL: '', // This field will be set using getLevelChartLinkParams in each view
    params: [
        {
            value: 'p_',
            isFilter: false,
            getFromDataset: false
        },
        {
            value: 's_',
            isFilter: false,
            getFromDataset: false
        },
        {
            value: 'l_',
            isFilter: true,
            getFromDataset: false
        }
    ]
};

const CHART_LINK_BY_segment = {
    baseURL: '', // This field will be set in each view
    params: [
        {
            value: 'p_',
            isFilter: true,
            getFromDataset: true
        },
        {
            value: 's_',
            isFilter: false,
            getFromDataset: false
        },
        {
            value: 'l_',
            isFilter: false,
            getFromDataset: false
        }
    ]
};

const CHART_LINK_BY_SECTION = {
    baseURL: '', // This field will be set in each view
    params: [
        {
            value: 'p_',
            isFilter: false,
            getFromDataset: false
        },
        {
            value: 's_',
            isFilter: true,
            getFromDataset: true
        },
        {
            value: 'l_',
            isFilter: false,
            getFromDataset: false
        }
    ]
};

const CHART_LINK_BY_STATUS = {
    baseURL: '', // This field will be set in each view
    params: [
        {
            value: 'dt_',
            isFilter: false,
            getFromDataset: false
        },
        {
            value: 'p_',
            isFilter: false,
            getFromDataset: false
        },
        {
            value: 's_',
            isFilter: false,
            getFromDataset: false
        },
        {
            value: 'd_',
            isFilter: false,
            getFromDataset: false
        },
        {
            value: 'st_',
            isFilter: true,
            getFromDataset: false
        }
    ]
};

const CHART_LINK_BY_DATE = {
    baseURL: '', // This field will be set in each view
    params: [
        {
            value: 'dt_',
            isFilter: true,
            getFromDataset: false
        },
        {
            value: 'p_',
            isFilter: true,
            getFromDataset: true
        },
        {
            value: 's_',
            isFilter: false,
            getFromDataset: false
        },
        {
            value: 'd_',
            isFilter: false,
            getFromDataset: false
        }
    ]
};

const CHART_LINK_BY_segment_LEVEL = {
    baseURL: '', // This field will be set in each view
    params: [
        {
            value: 'p_',
            isFilter: true,
            getFromDataset: true
        },
        {
            value: 's_',
            isFilter: false,
            getFromDataset: false
        },
        {
            value: 'l_',
            isFilter: true,
            getFromDataset: false
        }
    ]
};

const CHART_LINK_BY_SECTION_LEVEL = {
    baseURL: '', // This field will be set in each view
    params: [
        {
            value: 'p_',
            isFilter: false,
            getFromDataset: false
        },
        {
            value: 's_',
            isFilter: true,
            getFromDataset: true
        },
        {
            value: 'l_',
            isFilter: true,
            getFromDataset: false
        }
    ]
};

getChartLinkParams = function (baseURL, link_params) {
    let level_chart_link = link_params;
    level_chart_link.baseURL = baseURL

    return level_chart_link;
}

onHoverChart = function (chartSelector, item) {
    chartSelector.css('cursor', item.length > 0 ? 'pointer' : 'default');
}

onClickChart = function (datasets, link, e, item, ids = false) {
    let link_url = link.baseURL;

    if (item[0]) {
        if (link.urls) {
            location.href = link.urls[item[0].index].value;
        } else {
            // If there's an urlParam field in the link, use the item index in the URL
            if (link.urlParam) {
                link_url = getUrlParam(link_url, item, link, ids);
            }

            link.params.forEach(function (param) {
                link_url += (param.value + getFilterValue(e, item, param, datasets, ids));
            });

            location.href = link_url;
        }
    }
}

getUrlParam = function (link_url, item, link, ids) {
    if (ids) { // In some cases, we need to set the url params ourselves, using the ids field
        if (ids[item[0].index] === null) {
            return link_url;
        }

        return link_url + ids[item[0].index]  + '/';
    }

    return link_url + item[0].index + '/';
}

getFilterValue = function (e, item, param, datasets, ids) {
    if (param.isFilter) {
        if (param.filter_value) {
            return param.filter_value;
        }

        if (param.getFromDataset) {
            let dataset_index = item[0].datasetIndex;
            let data_index = item[0].index;

            return ids ? ids[data_index] : datasets[dataset_index].labelId;
        }

        let label = getLabel(e, item);

        if (param.value === 'dt_') {
            if (label.length > 2) {
                let lb = label.split('/');

                return lb[0] + lb[1];
            }

            return "0" + ("0" + label).slice(-2);
        } else {
            return label;
        }
    }

    return '-1';
}

getLabel = function (e, item) {
    // If there's no scales, then it's a doughnut chart, so we get the label from a different place
    if (Object.keys(e.chart.scales).length === 0 && e.chart.scales.constructor === Object) {
        let labels = e.chart.legend.legendItems;

        return labels[item[0].index].text;
    } else {
        let labels = e.chart.data.labels;

        return labels[item[0].index];
    }
}

getDoughnutChart = function (chartSelector, labels, values, link = false, ids = false) {
    let datasets = [{
        data: values,
        backgroundColor: DOUGHNUT_CHART_COLORS,
        hoverBackgroundColor: DOUGHNUT_CHART_COLORS
    }];

    let options = {
        maintainAspectRatio: false,
        plugins: {
            datalabels: {
                formatter: (value, ctx) => {
                    let total = ctx.chart.getDatasetMeta(0).total;
                    let percentage = value*100 / total;
                    let label = (percentage).toFixed(0)+"%";
                    return percentage < 5 ? '' : label;
                },
                color: '#fff',
                font: {
                    size: 14
                },
                clip: true,
            },
            legend: {
                labels: {
                    usePointStyle: true,
                    pointStyle: 'circle',
                    boxWidth: 10
                }
            }
        }
    };

    if (link) {
        options.onHover = (e, item) => { onHoverChart(chartSelector, item); };
        options.onClick = (e, item) => { onClickChart(datasets, link, e, item, ids); };
    }

    return new Chart(chartSelector, {
        type: 'doughnut',
        plugins: [ChartDataLabels],
        data: {
            labels: labels,
            datasets: datasets
        },
        options: options
    });
}

getSimpleBarChart = function (chartSelector, labels, datasetLabel, values, link = false, ids = false) {
    let options = {
        plugins: {
            legend: {
                labels: {
                    usePointStyle: true,
                    pointStyle: 'circle',
                    boxWidth: 10
                }
            }
        },
        maintainAspectRatio: false,
        scales: {
            x: {
                grid: {
                    display: false
                }
            },
            y: {
                beginAtZero: true,
            }
        }
    };

    let datasets = [
        {
            label: datasetLabel,
            backgroundColor: SIMPLE_BAR_CHART_COLOR,
            hoverBackgroundColor: SIMPLE_BAR_CHART_COLOR,
            borderColor: "#fff",
            data: values,
            spanGaps: false
        }
    ];

    if (link) {
        options.onHover = (e, item) => { onHoverChart(chartSelector, item); };
        options.onClick = (e, item) => { onClickChart(datasets, link, e, item, ids); };
    }

    return new Chart(chartSelector, {
        type: 'bar',
        data: {
            labels: labels,
            datasets: datasets
        },
        options: options
    });
}

getStackedBarChart = function (chartSelector, labels, datasets, link = false) {
    let options = {
        plugins: {
            legend: {
                labels: {
                    usePointStyle: true,
                    pointStyle: 'circle',
                    boxWidth: 10
                }
            }
        },
        maintainAspectRatio: false,
        scales: {
            x: {
                stacked: true,
                grid: {
                    display: false
                }
            },
            y: {
                stacked: true
            }
        }
    };

    if (link) {
        options.onHover = (e, item) => { onHoverChart(chartSelector, item); };
        options.onClick = (e, item) => { onClickChart(datasets, link, e, item); };
    }

    return new Chart(chartSelector, {
        type: 'bar',
        data: {
            labels: labels,
            datasets: datasets
        },
        options: options
    });
}

getMixedStackedBarChart = function (chartSelector, labels, datasets, link = false, ids = false) {
    let options = {
        plugins: {
            legend: {
                labels: {
                    usePointStyle: true,
                    pointStyle: 'circle',
                    boxWidth: 10
                }
            }
        },
        maintainAspectRatio: false,
        scales: {
            x: {
                stacked: true,
                grid: {
                    display: false
                }
            },
            y: {
                stacked: true
            }
        }
    };

    if (link) {
        options.onHover = (e, item) => { onHoverChart(chartSelector, item); };
        options.onClick = (e, item) => { onClickChart(datasets, link, e, item, ids); };
    }

    return new Chart(chartSelector, {
        type: 'bar',
        data: {
            labels: labels,
            datasets: datasets
        },
        options: options
    });
}

getLineChart = function (chartSelector, labels, datasets, showLegend = true) {
    return new Chart(chartSelector, {
        type: 'line',
        data: {
            labels: labels,
            datasets: datasets
        },
        options: {
            plugins: {
                legend: {
                    display: showLegend,
                    labels: {
                        usePointStyle: true,
                        pointStyle: 'circle',
                        boxWidth: 10
                    }
                }
            },
            fill: false,
            tension: 0.4,
            scales: {
                x: {
                    stacked: true
                },
                y: {
                    stacked: false,
                    min: 0,               // Fuerza el valor mínimo del eje y a 0
                    ticks: {
                        beginAtZero: true  // Asegura que los ticks comiencen en 0
                    }
                }
            }
        }
    });
}

getWebVitalsEvolutionChart = function (chartSelector, labels, values, reverseY = true, yAxisLabel = 'avg. Position') {
    // Calcular el máximo valor de los datos (ignorando null)
    const maxValue = Math.max(...values.filter(v => v !== null && v !== undefined));
    const suggestedMax = maxValue + 0.5;

    // Configuración del eje Y según el tipo de gráfico
    let yAxisConfig = {
        display: true,
        suggestedMax: suggestedMax,
        reverse: reverseY,
        ticks: {
            stepSize: 0.5
        },
        grid: {
            display: false
        },
        title: {
            display: true,
            text: yAxisLabel
        }
    };

    if (reverseY) {
        // Para gráficos de posición: rango desde 0.5 pero ticks empiezan en 1
        yAxisConfig.min = 0.5;
        yAxisConfig.ticks.callback = function(value) {
            return value >= 1 ? value : '';
        };
    } else {
        yAxisConfig.min = 0;
    }

    return new Chart(chartSelector, {
        type: 'line',
        data: {
            labels: labels,
            datasets: [
                {
                    data: values,
                    backgroundColor: ["#4a5a97"],
                    borderColor: "#4a5a97",
                    spanGaps: true  // Conecta puntos saltando valores null
                }
            ]
        },
        options: {
            plugins: {
                legend: {
                    display: false
                }
            },
            fill: false,
            tension: 0.4,
            scales: {
                x: {
                    display: true,
                    grid: {
                        display: false
                    }
                },
                y: yAxisConfig
            }
        }
    });
}
getWebVitalsEvolutionCompeChart = function (chartSelector, labels, values, reverseY = true, yAxisLabel = 'avg. Position') {
    // Calcular el máximo valor de los datos (ignorando null)
    const maxValue = Math.max(...values.filter(v => v !== null && v !== undefined));
    const suggestedMax = maxValue + 0.5;

    // Configuración del eje Y según el tipo de gráfico
    let yAxisConfig = {
        display: true,
        suggestedMax: suggestedMax,
        reverse: reverseY,
        ticks: {
            stepSize: 0.5
        },
        grid: {
            display: false
        },
        title: {
            display: true,
            text: yAxisLabel
        }
    };

    if (reverseY) {
        // Para gráficos de posición: rango desde 0.5 pero ticks empiezan en 1
        yAxisConfig.min = 0.5;
        yAxisConfig.ticks.callback = function(value) {
            return value >= 1 ? value : '';
        };
    } else {
        yAxisConfig.min = 0;
    }

    return new Chart(chartSelector, {
        type: 'line',
        data: {
            labels: labels,
            datasets: [
                {
                    label:"Competitors",
                    data: values,
                    backgroundColor: ["#f2798f"],
                    borderColor: "#f2798f",
                    spanGaps: true  // Conecta puntos saltando valores null
                }
            ]
        },
        options: {
            plugins: {
                legend: {
                    display: false
                }
            },
            fill: true,
            tension: 0.4,
            scales: {
                x: {
                    display: true,
                    grid: {
                        display: false
                    },
                },
                y: yAxisConfig
            }
        }
    });
}
getEvolutionCompeGrouppedChart = function (chartSelector, labels, values,labels2,values2,project, reverseY = true, yAxisLabel = 'avg. Position', competitorLabel = 'Competitors') {
    // Calcular el máximo valor de ambos datasets (ignorando null)
    const maxValue1 = Math.max(...values.filter(v => v !== null && v !== undefined));
    const maxValue2 = Math.max(...values2.filter(v => v !== null && v !== undefined));
    const maxValue = Math.max(maxValue1, maxValue2);
    const suggestedMax = maxValue + 0.5;

    // Configuración del eje Y según el tipo de gráfico
    let yAxisConfig = {
        display: true,
        suggestedMax: suggestedMax,
        reverse: reverseY,
        ticks: {
            stepSize: 0.5
        },
        grid: {
            display: false
        },
        title: {
            display: true,
            text: yAxisLabel
        }
    };

    if (reverseY) {
        // Para gráficos de posición: rango desde 0.5 pero ticks empiezan en 1
        yAxisConfig.min = 0.5;
        yAxisConfig.ticks.callback = function(value) {
            return value >= 1 ? value : '';
        };
    } else {
        yAxisConfig.min = 0;
    }

    return new Chart(chartSelector, {
        type: 'line',
        data: {
            labels: labels,
            datasets: [
                {
                    label: project,
                    data: values,
                    backgroundColor: ["#4a5a97"],
                    borderColor: "#4a5a97",
                    spanGaps: true  // Conecta puntos saltando valores null
                },
                {
                    label: competitorLabel,
                    data: values2,
                    backgroundColor: ["#f2798f"],
                    borderColor: "#f2798f",
                    spanGaps: true  // Conecta puntos saltando valores null
                }
            ]
        },
        options: {
            plugins: {
                legend: {
                    display: true,
                    labels: {
                        usePointStyle: true,
                    }
                }
            },
            fill: false,
            tension: 0.4,
            scales: {
                x: {
                    display: true,
                    beginAtZero: true,
                    grid: {
                        display: false
                    }
                },
                y: yAxisConfig
            }
        }
    });
}
getEvolutionCompeChart = function (chartSelector, labels, projectValues, competitorsData, project) {
    // Calcular el máximo valor de todos los datasets (proyecto + competidores)
    let allValues = [...projectValues.filter(v => v !== null && v !== undefined)];
    competitorsData.forEach(competitor => {
        allValues = allValues.concat(competitor.values.filter(v => v !== null && v !== undefined));
    });
    const maxValue = Math.max(...allValues);
    const suggestedMax = maxValue + 0.5;

    // Crear un array de datasets, uno para el proyecto y uno para cada competidor
    const datasets = [
        {
            label: project,
            data: projectValues,
            backgroundColor: "#4a5a97",
            borderColor: "#4a5a97",
            fill: false,
            tension: 0.4,
            spanGaps: true  // Conecta puntos saltando valores null
        }
    ];

    // Añadir cada competidor a los datasets
    competitorsData.forEach(competitor => {
        const color = getRandomColor();

        datasets.push({
            label: competitor.name,
            data: competitor.values,
            backgroundColor: color,
            borderColor: color,
            fill: false,
            tension: 0.4,
            spanGaps: true  // Conecta puntos saltando valores null
        });
    });

    return new Chart(chartSelector, {
        type: 'line',
        data: {
            labels: labels,
            datasets: datasets
        },
        options: {
            plugins: {
                legend: {
                    display: true,
                    labels: {
                        usePointStyle: true,
                    }
                }
            },
            fill: false,
            tension: 0.4,
            scales: {
                x: {
                    display: true,
                    beginAtZero: true,
                    grid: {
                        display: false
                    }
                },
                y: {
                    display: true,
                    min: 0.5,             // Rango desde 0.5 para dar espacio visual
                    suggestedMax: suggestedMax,  // Máximo valor + 0.5
                    reverse: true,        // Invierte el eje Y para que 1 esté arriba
                    ticks: {
                        stepSize: 0.5,
                        callback: function(value) {
                            return value >= 1 ? value : '';  // Solo muestra etiquetas desde 1
                        }
                    },
                    grid: {
                        display: false
                    },
                    title: {              // Configuración del título del eje Y
                        display: true,
                        text: 'avg. Position'
                    }
                },
            }
        }
    });
}


getBarEvolutionChart = function (chartSelector, labels, values) {
    return new Chart(chartSelector, {
        type: 'bar',
        data: {
            labels: labels,
            datasets: values,
        },
        options: {
            scales: {
                y: {
                    beginAtZero: true
                }
            }
        },
    });
}

getWebVitalsChart = function (chartSelector, labels, fast, avg, slow, barThickness = 30) {
    let xAxisMaxValue = fast[0] + avg[0] + slow[0];

    let chartConfig = {
        type: 'bar',
        data: {
            labels: labels,
            datasets: [
                {
                    label: "Fast",
                    data: fast,
                    backgroundColor: ["#00cc9b"],
                    borderColor: "#fff"
                },
                {
                    label: "Average",
                    data: avg,
                    backgroundColor: ["#FFCE56"],
                    borderColor: "#fff"
                },
                {
                    label: "Slow",
                    data: slow,
                    backgroundColor: ["red"],
                    borderColor: "#fff"
                }
            ]
        },
        options: {
            barThickness: barThickness,
            plugins: {
                legend: {
                    display: false
                },
                tooltip: {
                    // Disable the on-canvas tooltip
                    enabled: false,
                    external: function(context) {
                        // Tooltip Element
                        let tooltipEl = document.getElementById('chartjs-tooltip');

                        // Create element on first render
                        if (!tooltipEl) {
                            tooltipEl = document.createElement('div');
                            tooltipEl.id = 'chartjs-tooltip';
                            tooltipEl.innerHTML = '<table style="width: 110px; height: 50px"></table>';
                            document.body.appendChild(tooltipEl);
                        }

                        // Hide if no tooltip
                        const tooltipModel = context.tooltip;
                        if (tooltipModel.opacity === 0) {
                            tooltipEl.style.opacity = 0;
                            return;
                        }

                        // Set caret Position
                        tooltipEl.classList.remove('above', 'below', 'no-transform');
                        if (tooltipModel.yAlign) {
                            tooltipEl.classList.add(tooltipModel.yAlign);
                        } else {
                            tooltipEl.classList.add('no-transform');
                        }

                        function getBody(bodyItem) {
                            return bodyItem.lines;
                        }

                        // Set Text
                        if (tooltipModel.body) {
                            const titleLines = tooltipModel.title || [];
                            const bodyLines = tooltipModel.body.map(getBody);

                            let innerHtml = '<thead>';

                            titleLines.forEach(function(title) {
                                innerHtml += '<tr><th class="text-white" style="padding: 10px 10px 2px 10px">' + title + '</th></tr>';
                            });
                            innerHtml += '</thead><tbody>';

                            bodyLines.forEach(function(body, i) {
                                const colors = tooltipModel.labelColors[i];
                                let style = 'background:' + colors.backgroundColor;
                                style += '; border-color:' + colors.borderColor;
                                style += '; border-width: 2px';
                                const span = '<span style="' + style + '"></span>';
                                let squareColor = 'background-color:' + colors.backgroundColor + ';';
                                const square = '<div style="display: inline-block; border: 1px solid #fff; margin-right: 5px; height: 10px; width: 10px; ' + squareColor + '"></div>';
                                innerHtml += '<tr><td class="text-white" style="padding: 2px 10px 10px 10px">' + square + span + body + '</td></tr>';
                            });
                            innerHtml += '</tbody>';

                            let tableRoot = tooltipEl.querySelector('table');
                            tableRoot.style.backgroundColor = '#000';
                            tableRoot.style.opacity = '0.8';
                            tableRoot.style.padding =  "100px";
                            tableRoot.style.borderRadius =  "4.5px";
                            tableRoot.innerHTML = innerHtml;
                        }

                        const position = context.chart.canvas.getBoundingClientRect();
                        const bodyFont = Chart.helpers.toFont(tooltipModel.options.bodyFont);

                        // Display, position, and set styles for font
                        tooltipEl.style.opacity = 1;
                        tooltipEl.style.position = 'absolute';
                        tooltipEl.style.left = position.left - window.pageXOffset + tooltipModel.caretX - 100 + 'px';
                        tooltipEl.style.top = position.top + window.pageYOffset + tooltipModel.caretY + 'px';
                        tooltipEl.style.font = bodyFont.string;
                        tooltipEl.style.padding = tooltipModel.padding + 'px ' + tooltipModel.padding + 'px';
                        tooltipEl.style.pointerEvents = 'none';
                    }
                }
            },
            indexAxis: 'y',
            scales: {
                x: {
                    min: 0,
                    max: xAxisMaxValue,
                    display: false,
                    stacked: true,
                    ticks: {
                        display: false, //this will remove only the label
                    },
                    grid: {
                        display:false
                    }
                },
                y: {
                    display: false,
                    stacked: true,
                    beginAtZero: true,
                    ticks: {
                        display: false, //this will remove only the label
                    },
                    grid: {
                        display:false
                    }
                }
            }
        }
    };

    return new Chart(chartSelector, chartConfig);
}

getCompetitorComparisonBarChart = function (chartSelector, labels, datasets) {
    return new Chart(chartSelector, {
        type: 'bar',
        data: {
            labels: labels,
            datasets: datasets
        },
        options: {
            indexAxis: 'y',
            plugins: {
                legend: {
                    position: 'right',
                    labels: {
                        usePointStyle: true,
                        pointStyle: 'circle',
                        boxWidth: 10
                    }
                }
            },
            scales: {
                y: {
                    grid: {
                        display: false
                    }
                }
            }
        }
    });
}

getComparisonBarChart = function (chartSelector, labels, datasets) {
    return new Chart(chartSelector, {
        type: 'bar',
        data: {
            labels: labels,
            datasets: datasets
        },
        options: {
            plugins: {
                legend: {
                    labels: {
                        usePointStyle: true,
                        pointStyle: 'circle',
                        boxWidth: 10
                    }
                }
            },
            scales: {
                x: {
                    grid: {
                        display: false,
                    }
                },
                y: {
                    beginAtZero: true
                }
            }
        }
    });
}

getCardDoubleHorizontalBarChart = function (chartName, chartSelector, labels, values) {
    return new Chart(chartSelector, {
        type: 'bar',
        data: {
            labels: labels,
            datasets: [
                {
                    data: values,
                    backgroundColor: ["#FFCE56","#4a5a97"],
                    borderColor: "#fff"
                }
            ]
        },
        options: {
            indexAxis: 'y',
            plugins: {
                legend: {
                    display: false
                },
                tooltip: {
                    display: false
                }
            },
            scales: {
                x: {
                    display: false,
                    grid: {
                        display: false
                    },
                    ticks: {
                        display:false
                    }
                },
                y: {
                    display: false,
                    grid: {
                        display: false
                    },
                    ticks: {
                        display:false
                    }
                },
            }
        }
    });
}

colorFromValue = function (value, border) {
    let alpha = (1 + (Math.log(value*20)) / 2);
    let color = '#e80026';

    if (border) {
        alpha += 0.01;
    }

    return Chart.helpers.color(color)
        .alpha(alpha)
        .rgbString();
}

getTreemapChart = function (chartSelector, label, values) {
    return new Chart(chartSelector, {
        type: 'treemap',
        data: {
            datasets: [
                {
                    label: label,
                    tree: values,
                    fontColor: '#000',
                    fontFamily: 'serif',
                    fontSize: 12,
                    fontStyle: 'normal',
                    backgroundColor: function(chartSelector) {
                        return colorFromValue(chartSelector.dataset.tree[(chartSelector.dataIndex)]);
                    }
                }
            ]
        }
    });
}

getVitalsChart = function (chartSelector, labels, values, colors, max) {
    let maxValue = values.reduce(function(a, b) {
        return Math.max(a, b);
    }, -Infinity);

    return new Chart(
        chartSelector,
        {
            type: 'bar',
            data: {
                labels: labels,
                datasets: [{
                    borderRadius: 5,
                    barPercentage: 0.5,
                    barThickness: 12,
                    maxBarThickness: 15,
                    data: values,
                    backgroundColor: colors
                }]
            },
            options: {
                plugins: {
                    legend: {
                        display: false
                    },
                    tooltip: {
                        enabled: true
                    }
                },
                scales: {
                    y: {
                        beginAtZero: true,
                        min: 0,
                            suggestedMax: max < maxValue ? maxValue : max,
                            grid: {
                            display: false
                        }
                    }
                }
            },
        }
    );
}
function getRandomColor() {
    const letters = '0123456789ABCDEF';
    let color = '#';
    for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
}
